/**
 * Конфиг по умолчанию для постраничного «показать ещё» в списке событий.
 *
 * mobileMaxWidthPx совпадает с SCSS @mixin mobile в
 * app/assets/scss/base/breakpoints.scss: max-width ($tablet-size - 1px) => 729.
 */
const showMoreConfig = {
  enabled: true,
  mobilePageSize: 3,
  desktopPageSize: 6,
  mobileMaxWidthPx: 729,
  buttonLabel: 'Показать ещё',
  resizeDebounceMs: 150,
  // При выборе дня в календаре раскрывать список до последней карточки на этот день.
  revealOnCalendarDateSelect: true,
};

export default showMoreConfig;
